module.exports = __webpack_public_path__ + "img/sport-29-@3x.47d95c04.png";